import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import { api } from "@/lib/site";
import { STATIC_GALLERY } from "@/lib/staticData";
import { motion } from "framer-motion";
import { X } from "lucide-react";

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/gallery")
      .then((r) => setItems(r.data))
      .catch(() => setItems(STATIC_GALLERY));
  }, []);

  return (
    <div data-testid="gallery-page">
      <PageHero eyebrow="GALLERY" title="Moments at Royal" subtitle="A glimpse into the vibrant life at Royal English High School." />

      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
            {items.map((g, i) => (
              <motion.button
                key={g.id}
                onClick={() => setActive(g)}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: (i % 6) * 0.05 }}
                data-testid={`gallery-item-${i}`}
                className="block w-full mb-5 break-inside-avoid group zoom-img rounded-2xl shadow-md hover:shadow-2xl transition-shadow relative"
              >
                <img src={g.image_url} alt={g.title} className="w-full h-auto rounded-2xl block" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-royal/90 via-royal/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl flex items-end p-5">
                  <p className="text-white font-semibold">{g.title}</p>
                </div>
              </motion.button>
            ))}
          </div>
          {items.length === 0 && (
            <p className="text-center text-gray-500 py-10">Gallery images coming soon...</p>
          )}
        </div>
      </section>

      {active && (
        <div data-testid="gallery-lightbox" onClick={() => setActive(null)}
          className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center p-6">
          <button onClick={() => setActive(null)} className="absolute top-6 right-6 text-white p-2" data-testid="gallery-close">
            <X size={28} />
          </button>
          <img src={active.image_url} alt={active.title} className="max-h-[85vh] max-w-[95vw] rounded-2xl" />
        </div>
      )}
    </div>
  );
}
